import React from "react"

function IconArrowNext({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (<svg  fill={color} fuze-icon="arrow-next"viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{height: height || fontSize}} originalclass="fz-icon fz-icon-arrow-next"{...props}><path d="m16.887 11.5-7.73-7.248a.873.873 0 0 0-1.47.637v14.495a.873.873 0 0 0 1.47.637l7.77-7.288a.873.873 0 0 0-.04-1.233zm-1.234.636-6.657 6.241V5.895l6.657 6.241z" fill={color} fillRule="evenodd" style={{height: height || fontSize}} originalclass="__primary"/></svg>)
}

export default IconArrowNext
